<script lang="ts">
	import type { Snippet } from "svelte";
	import UserRoundIcon from "@lucide/svelte/icons/user-round";

	let {
		displayName = "Team Member",
		title = "Title",
		headshot = null,
		bio = null,
		children
	}: {
		displayName?: string;
		title?: string;
		headshot?: string | null;
		bio?: string | null;
		children?: Snippet;
	} = $props();
</script>

<div class="bg-card border-border/50 rounded-2xl border p-6 shadow-sm">
	<div class="flex items-center gap-5">
		<div class="shrink-0">
			{#if headshot}
				<img
					class="ring-border/10 h-24 w-24 rounded-full object-cover ring-1"
					src={headshot}
					alt={displayName}
					width="96"
					height="96"
					loading="lazy"
				/>
			{:else}
				<div class="bg-accent flex h-24 w-24 items-center justify-center rounded-full">
					<UserRoundIcon class="text-muted-foreground h-10 w-10" />
				</div>
			{/if}
		</div>
		<div class="min-w-0 flex-1">
			<h3 class="text-foreground text-xl leading-tight font-semibold">{displayName}</h3>
			<p class="text-primary mt-1">{title}</p>
		</div>
	</div>
	{#if children}
		<div class="mt-4">
			{@render children()}
		</div>
	{:else if bio}
		<p class="text-muted-foreground mt-4 leading-relaxed text-pretty">{bio}</p>
	{/if}
</div>
